import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function EmotionalHook() {
  return <section className="py-24 px-4 bg-gradient-to-b from-[#FFF5F7] to-[#FEF0F3]" data-id="element-8">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-9">
        <FadeIn data-id="element-10">
          <p className="text-2xl md:text-3xl font-serif leading-relaxed text-[#4a2535] text-center italic opacity-90" data-id="element-11">
            "Hay un momento —muy silencioso— en el que dejás de discutir para
            resolver… y empezás a discutir para defenderte."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-12">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#7a5568]" data-id="element-13">
            <p data-id="element-14">No pasa de golpe. No hay un día exacto.</p>
            <p data-id="element-15">Solo aparece el cansancio.</p>
            <p data-id="element-16">
              Cansancio de explicar. De repetir. De volver a hablar de lo mismo
              esperando que, esta vez, algo cambie.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-17">
          <div className="bg-white p-8 rounded-2xl border border-[#f0d0dc] shadow-[0_8px_32px_rgba(196,96,122,0.08)] my-12" data-id="element-18">
            <p className="text-xl text-[#c4607a] mb-4 font-serif" data-id="element-19">
              Y cuando no cambia, aparece la pregunta que más duele:
            </p>
            <h3 className="text-3xl md:text-4xl font-serif text-[#2d1520] mb-6" data-id="element-20">
              "¿Qué estoy haciendo mal?"
            </h3>
            <p className="text-lg text-[#7a5568] mb-4" data-id="element-21">
              La respuesta es incómoda… pero profundamente liberadora.
            </p>

            <div className="flex items-start gap-4 mt-8" data-id="element-22">
              <span className="text-4xl" data-id="element-23">👉</span>
              <div data-id="element-24">
                <span className="text-3xl font-bold text-[#c4607a] block mb-2" data-id="element-25">
                  Nada.
                </span>
                <p className="text-xl text-[#2d1520]" data-id="element-26">
                  No estás fallando. No sos exagerada. No sos "difícil".
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-27">
          <p className="text-2xl md:text-3xl text-center font-serif text-[#4a2535] leading-relaxed border-t border-b border-[#f0d0dc] py-12" data-id="element-28">
            Lo estás haciendo bien. Solo estás atrapada en un ciclo emocional
            que nadie te enseñó a romper.
          </p>
        </FadeIn>
      </div>
    </section>;
}